import { forwardRef, useEffect } from "react";
import { Typography } from "@mui/material";
import { TextField } from "@mui/material";
import { Button, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import moment from "moment";

const WebAppDate = forwardRef(
  (
    {
      data,
      currentQuestion,
      scrollToQuestion,
      latestQuestion,
      profileNames,
      handlePayload,
      handleDisabled,
      value,
      latestStepQuestion,
      isEdit,
    },
    ref
  ) => {
    const nextQuestionHandler = (height, option) => {
      handlePayload(data, value);
      scrollToQuestion(data, height, value);
    };

    const handleValue = (value) => {
      handlePayload(data, value);
    };

    const today = moment().format("YYYY-MM-DD");

    // const reg = new RegExp("^([a-zA-Z0-9-]){0,1000}$");

    // const profiles = profileNames?.map((name) => name.toUpperCase())

    // useEffect(() => { handleDisabled(profiles.includes(value.toUpperCase()) || !reg.test(value)) }, [value])

    const { t } = useTranslation();
    return (
      <div
        style={{
          padding: "0px 10px",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
        ref={ref}
      >
        <>
          <Typography variant="subtitle1" sx={{ fontSize: "20px" }}>
            {t(data.question)}
          </Typography>
          <Grid container>
            <TextField
              id="outlined-basic"
              placeholder={t("web_app_launch_date")}
              InputProps={{ inputProps: { max: today } }}
              variant="outlined"
              fullWidth
              onChange={(e) => handleValue(e.target.value)}
              type="date"
              // error={checkName}
              // error={profiles.includes(value.toUpperCase()) || !reg.test(value.toUpperCase())}

              value={value}
              // disabled={isEdit}
            />
          </Grid>

          {currentQuestion === data.id &&
          currentQuestion !== latestQuestion &&
          !(isEdit && latestStepQuestion === data.id) ? (
            <>
              {" "}
              <Button
                onClick={(option) => {
                  nextQuestionHandler(ref.current.clientHeight, option);
                }}
                disabled={!value}
                style={{ height: "50px", marginTop: "20px" }}
                color="secondary"
                variant="contained"
                fullWidth
              >
                {t("next")}
              </Button>
            </>
          ) : (
            <></>
          )}
        </>
      </div>
    );
  }
);

export default WebAppDate;
